import { CSRF_HEADER } from '$src/api/constants';

export function setCSRFHeader(request, token) {
  request.headers[CSRF_HEADER] = token;
}
